// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d2da003f","455":"2ec1433f","488":"89a3bd1c"}[chunkId] + ".chunk.js";
};